<app-loading
  [loading] = loading
></app-loading>
<div class="row">
  <div class="col-md-12">
    <app-tabela titulo="Lista de feedback"
                placeHolder="Buscar"
                [colunas]="colunas"
                [linhas]="linhas"
                [botaoEditar]="false"
    ></app-tabela>
  </div>
</div>
